import moment from "moment";

export const DataBr = (dados) => {
  if (dados) return moment(dados).format("DD/MM/YY");
  else return "-";
};

export const DataDb = (dados) => moment(dados).format("YYYY-MM-DD");

export const HoraBr = (dados) => {
  if (dados) return moment(dados).format("HH:mm:ss");
  else return "-";
};

export const Hora = (dados) => {
  if (dados) return moment(dados).format("HH:mm");
  else return "-";
};

export const Ambiente = (valor) => {
  if (valor === "1") return "Presencial";
  else if (valor === "2") return "Online";
  else if (valor === "5") return "Embarcada";
  else return valor;
};

export const Contingencia = (valor) => {
  if (valor === "1") return "Não";
  else if (valor === "2") return "Sim";
  else return valor;
};

export const MoedaBr = (dados, real = true) => {
  if (real) {
    if (dados || dados === 0)
      return dados.toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL",
      });
    else return "-";
  } else {
    if (dados || dados === 0)
      return dados.toLocaleString("pt-BR", { minimumFractionDigits: 2 });
    else return "-";
  }
};

export const Moeda = (dados) => {
  if (dados || dados === 0)
    return dados.toLocaleString("pt-BR", { minimumFractionDigits: 2 });
  else return "-";
};

export const TipoPix = (dados) => {
  let tipo = "";

  if (dados === 1) tipo = "Pagamento";
  else if (dados === 2) tipo = "Cancelamento";
  else if (dados === 3) tipo = "Taxa";
  else if (dados === 4) tipo = "Depósito";
  else tipo = dados;

  return tipo;
};

export const FormaPagto = (valor) => {
  if (valor === "01") return "Dinheiro";
  else if (valor === "02") return "Cheque";
  else if (valor === "03") return "Crédito";
  else if (valor === "04") return "Débito";
  else if (valor === "05") return "Vale";
  else if (valor === "06") return "Pix";
  else if (valor === "99") return "Outros";
  else return valor;
};

export const Bandeira = (valor) => {
  if (valor === "01") return "Visa";
  else if (valor === "02") return "Mastercard";
  else if (valor === "03") return "AMEX";
  else if (valor === "04") return "Sorocred";
  else if (valor === "05") return "Elo";
  else if (valor === "06") return "Diners";
  else if (valor === "99") return "Outros";
  else return valor;
};

export const Status = (valor) => {
  if (!valor) return "Normal";
  else if (valor === "110111") return "Cancelada";
  else if (valor === "110115") return "Não embarque";
  else if (valor === "240140") return "Revalidada";
  else return valor;
};

export const Rodoviaria = (valor) => {
  if (valor === "116") return "Pelotas";
  else if (valor === "1" || valor === "401") return "Porto Alegre";
  else if (valor === "122") return "Rio Grande";
  else if (valor === "21") return "Canguçu";
  else if (valor === "237") return "Piratini";
  else if (valor === "252") return "Santa Vitória";
  else if (valor === "74") return "Chui";
  else if (valor === "503") return "Quinta";
  else if (valor === "172") return "Pedro Osório";
  else if (valor === "91") return "Jaguarão";
  else if (valor === "114") return "Pinheiro Machado";
  else if (valor === "271A") return "Cassino";
  else if (valor === "900") return "Estrada";
  else return valor;
};

export const Percent = (valor = 0, total = 1) =>
  "(" + (((valor / total) * 100).toFixed(1) + "%").replace(".", ",") + ")";

export const Porcento = (valor) => {
  if (valor > 0) return +valor + "%";
  return "";
};

export const DataBanco = (data = undefined) =>
  moment(data).format("YYYY-MM-DD");

export const DataBancoUtc = (data = undefined) =>
  moment(data).utc().format("YYYY-MM-DD");

export const DataUsuario = (data = undefined) =>
  moment(data).format("DD/MM/YY");

export const HoraUsuario = (hora = undefined) => moment(hora).format("HH:mm");
